import { render, staticRenderFns } from "./query_lifeGuard.vue?vue&type=template&id=4cdea336&scoped=true&"
import script from "./query_lifeGuard.vue?vue&type=script&lang=js&"
export * from "./query_lifeGuard.vue?vue&type=script&lang=js&"
import style0 from "./query_lifeGuard.vue?vue&type=style&index=0&id=4cdea336&scoped=true&lang=css&"
import style1 from "./query_lifeGuard.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cdea336",
  null
  
)

export default component.exports